import React, { useState, useCallback } from "react";
import IconClose from "../../../assets/cross-icon.svg";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import greyDrop from "../../../assets/grey-drop-down-arrow.svg";
import activeIcon from "../../../assets/activeIcon.svg";
import archiveIcon from "../../../assets/archiveIcon.svg";
import allIcon from "../../../assets/IconAll.svg";
import TooltipCustom from "../../createAgenda/TooltipCustom";
import { capitalizeFirstAfterSpace } from "../../../helper";

export function Archive({ sortBy = [], onChangeArchive }) {
  const [projectType, setState] = useState(false);
  const [selectType, setSelecType] = useState("ACTIVE");

  return (
    <div
      className={`dropdown field-sort ${projectType ? "visible" : ""}`}
      onClick={() => setState(!projectType)}
    >
      <div className={`dropdown-overlay ${projectType ? "visible" : ""}`} />
      <OverlayTrigger
        trigger="hover"
        defaultShow={false}
        placement="top"
        popperConfig={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [-30, 0]
              }
            }
          ]
        }}
        overlay={
          <Tooltip id={`tooltip-checking`} className="tooltip-archive-active">
            {capitalizeFirstAfterSpace(selectType) + " Projects"}
          </Tooltip>
        }
      >
        <div
          className="dropdown-archive-value"
          style={{
            background:
              selectType === "ALL"
                ? "linear-gradient(270deg, #17438F 0%, #194EA9 52%, #1A58C2 100%)"
                : selectType === "ACTIVE"
                ? "#00A657"
                : selectType === "ARCHIVED"
                ? "#F44849"
                : "#fff",
            border:
              selectType === "ALL"
                ? "none"
                : selectType === "ACTIVE"
                ? "#00A657"
                : selectType === "ARCHIVED"
                ? "#F44849"
                : "#fff"
          }}
        >
          <Image
            src={
              selectType == "ACTIVE"
                ? activeIcon
                : selectType == "ALL"
                ? allIcon
                : archiveIcon
            }
            alt=""
            className={selectType != "" ? "dropdown-icon-archive" : ""}
            style={{ marginRight: "15px", width: "20px" }}
          />
          <Image
            className={selectType != "" ? "dropdown-icon-archive" : ""}
            src={greyDrop}
            alt=""
          />
        </div>
      </OverlayTrigger>
      <div className="dropdown-option-list hidden-mobile">
        <div className="dropdown-option-list-heading" />
        {sortBy
          ? sortBy.map(value => {
              return (
                <div
                  onClick={e => {
                    onChangeArchive(value);
                    setSelecType(value.key);
                  }}
                  style={{ display: "flex", gap: "8px" }}
                >
                  <Image src={value.image} style={{ width: "16px" }} />
                  <span className="label-archive">{value.label}</span>
                </div>
              );
            })
          : null}
      </div>
    </div>
  );
}
